import axios from 'axios';
import { useEffect, useState } from 'react';
import { Fade, Slide, Bounce, Zoom } from "react-awesome-reveal";
import './styles.scss';

export const NotFound = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Page not found - Wrongful Death News & Opinions';
    }, []);


    return <Fade delay={1}>
        <main id="main" className="not-found">
            <section id="banner" className="default-banner">
                <div className="inner-wrapper">
                    <h1>Error 404 - Page Not Found</h1>
                </div>
            </section>
        </main>
    </Fade>
    
}